import { updateColumnCount, safeFetch, reanimateImages } from "../utilities/utils"

class Blog extends HTMLElement {
  constructor() {
    super()
    this.tags = new Set()
    this.parser = new DOMParser()
    this.originalPathname = this.getOriginalPathname()
  }

  connectedCallback() {
    this.load()
    this.loadPagination()
    this.updateActiveFiltersCount()

    if (document.querySelector(".facets form")) {
      const filterForm = document.querySelector(".facets form")
      const inputElements = filterForm.querySelectorAll('input[type="checkbox"]')

      if (inputElements.length > 0) {
        inputElements.forEach((inputElement) => {
          inputElement.addEventListener("change", (e) => {
            const tag = e.target.value

            if (e.target.checked) {
              this.tags.add(tag)
            } else {
              this.tags.delete(tag)
            }

            this.updateActiveFiltersCount()

            const newUrl = this.getUrl(Array.from(this.tags))
            window.history.pushState({}, "", newUrl)
            this.updateContent(newUrl)
            this.scrollIntoView()
          })

          this.tags.length &&
            this.tags.find((tag) => tag === inputElement.value) !== undefined &&
            inputElement.setAttribute("checked", true)
        })
      }
    }

    updateColumnCount()
  }

  getOriginalPathname = () => {
    const [originalPathname] = window.location.pathname.split("/tagged/")
    return originalPathname.endsWith("/") ? originalPathname : `${originalPathname}/`
  }

  getInitialTags = () => {
    const hasTags = window.location.pathname.includes("/tagged/")
    if (hasTags) {
      const [, initialJoined] = window.location.pathname.split("/tagged/")
      return initialJoined.split("+")
    }
    return []
  }

  scrollIntoView = () => {
    const content = document.querySelector("#blog-content")
    if (content) content.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  updateActiveFiltersCount = () => {
    const sectionId = document.querySelector("#main-blog")?.dataset.sectionId
    const countEl = sectionId ? document.querySelector(`#active-filters-count-${sectionId}`) : null

    if (countEl) {
      countEl.textContent = this.tags.size > 0 ? this.tags.size : ""
    }
  }

  load = () => {
    const initialTags = this.getInitialTags()
    const inputElements = document.querySelectorAll('input[name="tag"]')

    initialTags.forEach((tag) => {
      this.tags.add(tag)
    })

    if (inputElements.length > 0) {
      inputElements.forEach((inputElement) => {
        if (this.tags.has(inputElement.value)) {
          inputElement.setAttribute("checked", true)
        }
      })
    }
  }

  loadPagination = () => {
    const pagination = document.querySelector(".pagination")

    if (pagination) {
      pagination.addEventListener("click", (e) => {
        if (e.target.tagName === "A") {
          e.preventDefault()
          const newUrl = e.target.href
          window.history.pushState({}, "", newUrl)
          this.updateContent(newUrl)
          setTimeout(this.scrollIntoView, 1000)
        }
      })
    }
  }

  getUrl = (tags = []) => {
    if (tags.length > 0) {
      return `${this.originalPathname}tagged/${tags.join("+")}?page=1`
    }

    return this.originalPathname
  }

  updateContent = async (newUrl) => {
    const blogSectionId = document.querySelector("#main-blog").dataset.sectionId
    const heroElement = document.querySelector("#hero-basic")
    const heroSectionId = heroElement ? heroElement.dataset.sectionId : null

    const blogUrl = newUrl.includes("?")
      ? `${newUrl}&section_id=${blogSectionId}`
      : `${newUrl}?section_id=${blogSectionId}`

    const heroUrl = heroSectionId ? (newUrl.includes("?")
      ? `${newUrl}&section_id=${heroSectionId}`
      : `${newUrl}?section_id=${heroSectionId}`) : null

    const blogResponse = await safeFetch(blogUrl);
    const heroResponse = heroUrl ? await safeFetch(heroUrl) : null

    if (blogResponse.error) {
      console.error(blogResponse.error)
    }

    const parsedBlog = this.parser.parseFromString(await blogResponse.response.text(), "text/html")

    const container = parsedBlog.querySelector(".grid-archive__content")

    const hasError = container.innerHTML.includes("Liquid error")

    if (hasError) {
      container.style.gridTemplateColumns = "1fr";
      container.innerHTML =
        '<p class="nothing_found"><strong>' +
        searchStrings.nothing_found +
        "</strong>" +
        searchStrings.try_different_filters +
        "</p>"
    }

    document.querySelector("#blog-content").innerHTML =
      parsedBlog.querySelector("#blog-content").innerHTML

    const blogContent = document.querySelector("#blog-content")
    reanimateImages(blogContent)
    blogContent?.querySelectorAll(".icon").forEach((icon) => {
      icon.classList.add("loaded")
    })

    if (heroResponse) {
      if (heroResponse.error) {
        console.error(heroResponse.error)
      } else {
        const parsedHero = this.parser.parseFromString(
          await heroResponse.response.text(),
          "text/html",
        )

        parsedHero.querySelectorAll(".icon").forEach((icon) => {
          icon.classList.add("loaded")
        });

        document.querySelector(".hero-basic .container").innerHTML =
          parsedHero.querySelector(".hero-basic .container").innerHTML
      }
    }

    this.loadPagination()
    updateColumnCount()
  }
}

if (!customElements.get("blog-component")) {
  customElements.define("blog-component", Blog)
}
